import React from 'react';
import { Link } from "react-router-dom";
import { getAllPosts } from '../data/blogPosts';

const formatDate = (d) => new Date(d).toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' });

const Blog = () => {
  const blogPosts = getAllPosts();

  return (
    <div className="dt">
      <section className="dt-hero dt-page-hero">
        <div className="dt-wrap">
          <h1 className="dt-page-title">Notes on making decisions stick</h1>
          <p className="dt-hero-sub">Guides and frameworks for teams that decide things in Slack.</p>
        </div>
      </section>
      <section className="dt-section dt-section--surface">
        <div className="dt-wrap dt-posts">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.slug}`} className="dt-post-card">
              {post.featuredImage && (
                <div className="dt-post-img">
                  <img src={post.featuredImage} alt={post.imageAlt || ''} loading="lazy" />
                </div>
              )}
              <div className="dt-post-body">
                <p className="dt-post-meta">
                  {formatDate(post.date)}
                  {post.isFree && <span className="dt-pill">Free framework</span>}
                </p>
                <h2 className="dt-h3">{post.title}</h2>
                <p className="dt-post-excerpt">{post.excerpt}</p>
                <span className="dt-post-more">Read <span aria-hidden="true">→</span></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Blog;



// WEBPACK FOOTER //
// ./src/components/Blog.js